export default __webpack_public_path__ + "static/media/radio.7b0cc48a.png";